import flatpickr from "flatpickr";
import {convertDateStringIntoYYYYMMDD} from "../Utils/Utils.js";

const ACFBlockBookRoomParameterBooking = (domEl) => {

	// Get the booking link with params
	let bookingLink = domEl.dataset.bookingLink;

	// Initialize the book button. We'll update the href attribute when changes are made to the input
	const bookButtonLink = domEl.querySelector('.book-button a');
	bookButtonLink.addEventListener('click', (e) => {

		// Input Fields
		const numRoomsEl = domEl.querySelector('[name="num-rooms"]');
		const adultsEl = domEl.querySelector('[name="adults"]');
		const childrenEl = domEl.querySelector('[name="children"]');
		const nightsEl = domEl.querySelector('[name="nights"]');

		// Create a new booking link
		const numRooms = numRoomsEl ? numRoomsEl.value : '';
		const adults = adultsEl ? adultsEl.value : '';
		const children = childrenEl ? childrenEl.value : '';
		const nights = nightsEl ? nightsEl.value : '';
		const product = null;

		const checkInDate = checkInCalendar.selectedDates[0]; // e.g. Wed Mar 22 2023 00:00:00 GMT+0100 (Central European Standard Time)
		const checkOutDate = checkInDate.fp_incr(nights); // e.g. Wed Mar 22 2023 00:00:00 GMT+0100 (Central European Standard Time)

		const arrivalDate = new Date(checkInDate);
		const departureDate = new Date(checkOutDate);

		bookButtonLink.href = bookingLink.slice()
			.replace('[NUM_ROOMS]', numRooms)
			.replace('[ADULTS]', adults)
			.replace('[CHILDREN]', children)
			.replace('[ARRIVAL_DATE]', convertDateStringIntoYYYYMMDD(arrivalDate))
			.replace('[DEPARTURE_DATE]', convertDateStringIntoYYYYMMDD(departureDate))
			.replace('[PRODUCT]', product);
	});

	// Initialize the date picker
	const checkInElement = domEl.querySelector('input[name="checkin"]');

	const checkInCalendar = new flatpickr(checkInElement, {
		monthSelectorType: 'dropdown',
		minDate: 'today',
		maxDate: new Date().fp_incr(365*3),
		dateFormat: 'd / m / Y',
		locale: {
			firstDayOfWeek: 1
		},
	});

};

export default ACFBlockBookRoomParameterBooking;